import createLogger, { LoggerColumns } from '../helpers/logger';
import { getElectronConfig, stripProtocol } from '../helpers/utils';

type envs = 'development' | 'production' | 'remoteServer';
const reactEnv: envs = (process.env.REACT_APP_ENV || 'production') as envs;

export const BASEPATH = '/nots/app/nots_player';

const logger = createLogger('variables.ts').columns([LoggerColumns.CONFIG]);

export const API_DOMAIN: string = (() => {
  const electronConfig = getElectronConfig();
  if (
    electronConfig?.communicationMode === 'socket' &&
    electronConfig?.socketServerIP
  ) {
    logger.log(
      `getting ip from electron config ${electronConfig.socketServerIP}`
    );
    return stripProtocol(electronConfig.socketServerIP);
  }
  return {
    development: 'localhost',
    remoteServer: 'notsbuilder.exacta-platform.com',
    production: window.location.hostname, //Need to update the domain based on the build
    remoteDb: 'notslms.exacta-platform.com',
    hermesysServer: 'notslms.exacta-platform.com',
  }[reactEnv];
})();
export const API_PORT: string = (() => {
  const electronConfig = getElectronConfig();
  if (
    electronConfig?.communicationMode === 'socket' &&
    electronConfig?.proxyServerPort
  ) {
    logger.log(
      `getting ip from electron config ${electronConfig.proxyServerPort}`
    );
    return electronConfig.proxyServerPort;
  }
  return {
    development: '8080',
    remoteServer: '443',
    production: '8088',
    remoteDb: '443',
    hermesysServer: '443',
  }[reactEnv];
})();

export const OFFLINE_API_PORT: string = (() => {
  if (
    process.env.REACT_APP_OFFLINE_API_PORT &&
    process.env.REACT_APP_OFFLINE_API_PORT.length > 0
  ) {
    return process.env.REACT_APP_OFFLINE_API_PORT;
  }
  return {
    development: '9090',
    remoteServer: '9090',
    production: '9090',
    remoteDb: '9090',
    hermesysServer: '9090',
  }[reactEnv];  
})();

export const CONTEXT_PATH = {
  development: '/nots',
  remoteServer: '/nots',
  production: '/nots',
  remoteDb: '/nots',
  hermesysServer: '/nots',
}[reactEnv];

export const OFFLINE_LESSON_SERVER = `http://${API_DOMAIN}:${OFFLINE_API_PORT}`;

console.log('PROXY ', API_DOMAIN, API_PORT, reactEnv);
logger.log('Builder API host init ', {
  API_DOMAIN,
  API_PORT,
  reactEnv,
});
